class CartMini extends HTMLElement {
  constructor() {
    super();

    this.cartMini = document.querySelector('cart-mini');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    
    document.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button.cart-mini__close').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );

    this.locationSpecificElements(this, 'mini-cart-countdown', 'none');
    this.locationSpecificElements(this, '[data-mini-shipping-notice]', 'none');
  }

  open() {

    this.classList.add('animate', 'active', 'open');
    
    this.cartMini.addEventListener('transitionend', () => {
      this.cartMini.focus();
      trapFocus(this.cartMini);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
    document.querySelector('body').classList.add('no-scroll');
  };

  close() {

    this.classList.remove('active', 'open');

    document.body.removeEventListener('click', this.onBodyClick);
    document.querySelector('cart-mini-trigger').resetState();

    removeTrapFocus(this.activeElement);
    document.querySelector('body').classList.remove('no-scroll');
  };

  locationSpecificElements (container, element, display) {

    const target = container.querySelector(element) || false;

    let name = "GlobalE_Data=";
    let ca = document.cookie.split(';');

    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];

      while (c.charAt(0) == ' ') {
          c = c.substring(1);
      }

      if (c.indexOf(name) == 0) {
        const data = JSON.parse(decodeURIComponent(c.substring(name.length, c.length)));

        if( data.currencyCode !== "USD" ){
         if( target != false ){
            target.style.display = display;
            return;
          }
        }
      }
    }
    // target.style.display = "none";
  }

  getSectionInnerHTML() {

    this.enableLoading();

    fetch(`${routes.cart_url}`)
      .then(response => response.text())
      .then(text => {
        
        const cartRaw = new DOMParser()
            .parseFromString(text, "text/html");

        this.getSectionsToRender().forEach((section => {
          
          const elementToReplace = document.getElementById(section.id),
                newElement = cartRaw.getElementById(section.id);

          if (newElement === undefined || newElement === null) return;

          elementToReplace.innerHTML = newElement.innerHTML;

          if( section.id == "cart-mini-footer" ){
            this.locationSpecificElements(this, '[data-mini-shipping-notice]', 'none')
          }
          
          if (section.id == "cart-mini-rebuy") {
            if (window.Rebuy) { Rebuy.init() };
          }
        }));

        const cartMiniCount = cartRaw.querySelector('#header-cart-count').innerHTML;
        document.querySelector('#header-cart-count').innerHTML = cartMiniCount;
      })
      .catch(e => {
        console.error(e);
        this.disableLoading();
      })
      .finally(e => {
        this.disableLoading();
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-mini-footer'
      },
      {
        id: 'cart-mini-items'
      },
      {
        id: 'mini-cart-countdown'
      },
      {
        id: 'discount-tiers'
      },
      {
        id: 'discount-notice'
      },
      {
        id: 'cart-mini-rebuy'
      }
    ];
  }

  enableLoading() {
    this.setAttribute("aria-busy", "true");
    // this.cartMini.querySelector('.loading-overlay').classList.remove('hidden');
  }

  disableLoading() {
    this.setAttribute("aria-busy", "false");
    // this.cartMini.querySelector('.loading-overlay').classList.add('hidden');
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.cartMini && !target.closest('cart-mini') && !target.closest('cart-mini-trigger') ) {
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-mini', CartMini);

class CartMiniRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-mini-items').updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-mini-remove-button', CartMiniRemoveButton);

class CartMiniItems extends HTMLElement {
  constructor() {
    super();

    this.cartMini = document.querySelector('cart-mini');

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  updateQuantity(line, quantity, name) {

    console.log("updateQuantity");

    this.cartMini.enableLoading();

    const body = JSON.stringify({
      line,
      quantity,
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {

        console.log("updateQuantity Fetch");

        this.cartMini.getSectionInnerHTML();

      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        document.getElementById('cart-errors').textContent = window.cartStrings.error;
      });
  }
}

customElements.define('cart-mini-items', CartMiniItems);